import styled from 'styled-components'

import { textStyles } from '../../theme'
import LoginForm from '../../components/forms/LoginForm'
import ForgotPasswordForm from '../../components/forms/ForgotPasswordForm'
import Link from '../../components/Link'
import Icon from '../../components/Icon'

export const Content = styled.div`
  padding: 4rem 2rem;
  flex-grow: 1;
`

export const Box = styled.div`
  max-width: 335px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const LogoIcon = styled(Icon)`
  width: 255px;
  margin: auto;
`

export const Image = styled.img`
  display: block;
  width: 100%;
  margin-top: 2rem;
`

export const Title = styled.h1`
  ${textStyles.titleH1};
  text-align: center;
  margin-top: 2rem;
`

export const LoginFormC = styled(LoginForm)`
  margin-top: 30px;
  width: 100%;
`

export const ForgotPasswordFormC = styled(ForgotPasswordForm)`
  margin-top: 55px;
  width: 100%;
`

export const ForgotPasswordLink = styled(Link)`
  margin: 30px auto auto auto;
  ${textStyles.text};
  display: inline-flex;
  align-items: center;
`

export const ForgotPasswordLinkIcon = styled(Icon)`
  position: relative;
  top: -2px;
  width: 14px;
  margin-right: 5px;
`
